function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import Log from '@deephaven/log';
import { isAuthPlugin, PluginType, isLegacyAuthPlugin, processLoadedModule, groupByDependencyLevel, getPluginModuleValue } from '@deephaven/plugin';
import loadRemoteModule from "./loadRemoteModule.js";
import { resolve } from "./remote-component.config.js";
var log = Log.module('@deephaven/app-utils.PluginUtils');

/**
 * @deprecated Import from `@deephaven/plugin` instead.
 */

/**
 * @deprecated Import from `@deephaven/plugin` instead.
 */

/**
 * @deprecated Import from `@deephaven/plugin` instead.
 */
export { getPluginModuleValue };

/**
 * Imports a commonjs plugin module from the provided URL
 * @param pluginUrl The URL of the plugin to load
 * @returns The loaded module
 */
export function loadModulePlugin(_x) {
  return _loadModulePlugin.apply(this, arguments);
}

/**
 * Loads a JSON file and returns the JSON object
 * @param jsonUrl The URL of the JSON file to load
 * @returns The JSON object of the manifest file
 */
function _loadModulePlugin() {
  _loadModulePlugin = _asyncToGenerator(function* (pluginUrl) {
    var myModule = yield loadRemoteModule(pluginUrl);
    return myModule;
  });
  return _loadModulePlugin.apply(this, arguments);
}
export function loadJson(_x2) {
  return _loadJson.apply(this, arguments);
}

/**
 * Load all plugin modules available based on the manifest file at the provided base URL.
 * Plugins are grouped into dependency levels and loaded in parallel within each
 * level. Levels are processed sequentially so that each level's exports are
 * registered in the module resolve map before the next level loads, enabling
 * cross-plugin imports via standard import statements.
 * @param modulePluginsUrl The base URL of the module plugins to load
 * @returns A map from the name of the plugin to the plugin module that was loaded
 */
function _loadJson() {
  _loadJson = _asyncToGenerator(function* (jsonUrl) {
    var res = yield fetch(jsonUrl);
    if (!res.ok) {
      throw new Error(res.statusText);
    }
    try {
      return yield res.json();
    } catch (_unused) {
      throw new Error('Could not be parsed as JSON');
    }
  });
  return _loadJson.apply(this, arguments);
}
export function loadModulePlugins(_x3) {
  return _loadModulePlugins.apply(this, arguments);
}
function _loadModulePlugins() {
  _loadModulePlugins = _asyncToGenerator(function* (modulePluginsUrl) {
    log.debug('Loading plugins...');
    try {
      var manifest = yield loadJson("".concat(modulePluginsUrl, "/manifest.json"));
      if (!Array.isArray(manifest.plugins)) {
        throw new Error('Plugin manifest JSON does not contain plugins array');
      }
      log.debug('Plugin manifest loaded:', manifest);
      var levels = groupByDependencyLevel(manifest.plugins);
      var pluginMap = new Map();

      // Load plugins level by level. Plugins within a level have no
      // inter-dependencies and load in parallel. Each level completes
      // before the next starts so cross-plugin imports resolve correctly.
      for (var lvl = 0; lvl < levels.length; lvl += 1) {
        var level = levels[lvl];

        // eslint-disable-next-line no-await-in-loop
        var results = yield Promise.allSettled(level.map(/*#__PURE__*/function () {
          var _ref7 = _asyncToGenerator(function* (plugin) {
            var name = plugin.name,
              main = plugin.main,
              version = plugin.version,
              loader = plugin.loader;
            var packageName = loader === null || loader === void 0 ? void 0 : loader.package;
            var pluginMainUrl = "".concat(modulePluginsUrl, "/").concat(name, "/").concat(main);
            var pluginExports = yield loadModulePlugin(pluginMainUrl);
            return {
              pluginExports,
              name,
              packageName,
              version
            };
          });
          return function (_x4) {
            return _ref7.apply(this, arguments);
          };
        }()));
        for (var r = 0; r < results.length; r += 1) {
          var result = results[r];
          if (result.status === 'fulfilled') {
            var _result$value = result.value,
              pluginExports = _result$value.pluginExports,
              name = _result$value.name,
              packageName = _result$value.packageName,
              version = _result$value.version;
            processLoadedModule(pluginMap, resolve, pluginExports, name, packageName, version);
          } else {
            log.error("Unable to load plugin '".concat(level[r].name, "'"), result.reason);
          }
        }
      }
      log.info('Plugins loaded:', pluginMap);
      return pluginMap;
    } catch (e) {
      log.error('Unable to load plugins:', e);
      return new Map();
    }
  });
  return _loadModulePlugins.apply(this, arguments);
}
export function getAuthHandlers(authConfigValues) {
  var _authConfigValues$get, _authConfigValues$get2;
  return (_authConfigValues$get = (_authConfigValues$get2 = authConfigValues.get('AuthHandlers')) === null || _authConfigValues$get2 === void 0 ? void 0 : _authConfigValues$get2.split(',')) !== null && _authConfigValues$get !== void 0 ? _authConfigValues$get : [];
}

/**
 * Get the auth plugin component from the plugin map and current configuration
 * Throws if no auth plugin is available
 *
 * @param pluginMap Map of plugins loaded from the server
 * @param authConfigValues Auth config values from the server
 * @param corePlugins Map of core auth plugins to include in the list. They are added after the loaded plugins
 * @returns The auth plugin component to render
 */
export function getAuthPluginComponent(pluginMap, authConfigValues) {
  var corePlugins = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Map();
  var authHandlers = getAuthHandlers(authConfigValues);
  // User plugins take priority over core plugins
  var authPlugins = [...pluginMap.entries(), ...corePlugins.entries()].filter(_ref => {
    var _ref2 = _slicedToArray(_ref, 2),
      plugin = _ref2[1];
    return isAuthPlugin(plugin) || isLegacyAuthPlugin(plugin);
  }).map(_ref3 => {
    var _ref4 = _slicedToArray(_ref3, 2),
      name = _ref4[0],
      plugin = _ref4[1];
    if (isLegacyAuthPlugin(plugin)) {
      return {
        type: PluginType.AUTH_PLUGIN,
        name,
        component: plugin.AuthPlugin.Component,
        isAvailable: plugin.AuthPlugin.isAvailable
      };
    }
    return plugin;
  });

  // Filter the available auth plugins
  var availableAuthPlugins = authPlugins.filter(_ref5 => {
    var isAvailable = _ref5.isAvailable;
    return isAvailable(authHandlers, authConfigValues);
  });
  if (availableAuthPlugins.length === 0) {
    throw new Error("No login plugins found, please register a login plugin for auth handlers: ".concat(authHandlers));
  } else if (availableAuthPlugins.length > 1) {
    log.warn('More than one login plugin available, will use the first one: ', availableAuthPlugins.map(_ref6 => {
      var name = _ref6.name;
      return name;
    }).join(', '));
  }
  var _availableAuthPlugins = availableAuthPlugins[0],
    name = _availableAuthPlugins.name,
    component = _availableAuthPlugins.component;
  log.info('Using LoginPlugin', name);
  return component;
}
//# sourceMappingURL=PluginUtils.js.map